<template>
  <v-layout xs12 md12 px-0 class="components-container">
    <v-flex v-if="agentData" class="agent-container-column">
      <agent-setting-page :profile="agentData" />
    </v-flex>
    <v-flex v-if="agentData" class="agent-container-column">
      <agent-upload-logo v-if="!isMobile" :profile="agentData" />
      <!-- <agent-supporting-contacts
        :profile="agentData"
      />-->
      <agent-invite-clients-page v-if="!isMobile" />
    </v-flex>
    <v-flex v-if="agentData && !isMobile" class="agent-container-column">
      <agent-pending-invites :profile="agentData" />
    </v-flex>
  </v-layout>
</template>

<script>
import { mapState } from 'vuex'
import AgentSettingPage from '../agent/AgentSettingsPage'
import AgentUploadLogo from '../agent/AgentUploadLogoPage'
// import AgentSupportingContacts from '../agent/AgentSupportingContacts'
import AgentInviteClientsPage from '../agent/AgentInviteClientsPage'
import AgentPendingInvites from '../agent/AgentPendingInvites'
export default {
  components: {
    AgentSettingPage,
    AgentUploadLogo,
    // AgentSupportingContacts,
    AgentInviteClientsPage,
    AgentPendingInvites
  },

  computed: {
    ...mapState('agent', ['agentData']),
    ...mapState('common', ['isMobile'])
  }
}
</script>

<style lang="sass">
.components-container
  display: flex
  flex-direction: row !important
  flex-wrap: wrap !important
  justify-content: center
  @media only screen and (max-width: 500px)
    flex-direction: column
.agent-container-column
  display: flex
  flex-direction: column
  justify-content: center
  width: 32% !important
  align-items: stretch
  @media only screen and (max-width: 1020px)
    width: 100% !important
    margin-top: 2rem
  @media only screen and (max-width: 450px)
    margin-top: 0
.agent-container-column:not(:first-child)
  margin-left: 2rem
  @media only screen and (max-width: 1020px)
    margin-left: 0
.agent-supporting-contacts, .agent-invite-clients
  margin-top: 2rem
</style>
